import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './PopoverArrow.scss';
var arrowSize = parseInt(s['arrow_size']);
var getArrowPosition = function (placement, position, containerSize) {
    var highLimit = containerSize - arrowSize * 2;
    var lowLimit = arrowSize;
    // The offset adjusts the arrow to point correctly to the reference.
    // We need this because our arrow is not centered by design.
    var offset = ['top', 'left'].includes(placement)
        ? arrowSize / 2
        : -arrowSize / 2;
    return Math.max(lowLimit, Math.min(highLimit, position + offset));
};
var getArrowPositionStyles = function (style, placement, contentWidth, contentHeight) {
    var left = style.left, top = style.top;
    if (Number.isInteger(left) && contentWidth) {
        left = getArrowPosition(placement, left, contentWidth);
    }
    else if (Number.isInteger(top) && contentHeight) {
        top = getArrowPosition(placement, top, contentHeight);
    }
    return __assign(__assign({}, style), { left: left, top: top });
};
/** Basic popover arrow component, does not apply any styles, only positioning.
 *  You will need to apply your own arrow svg etc. when using this
 */
var PopoverArrow = React.forwardRef(function (_a, ref) {
    var className = _a.className, wrapperClassName = _a.wrapperClassName, _b = _a.style, style = _b === void 0 ? {} : _b, simpleArrowPosition = _a.simpleArrowPosition, placement = _a.placement, contentWidth = _a.contentWidth, contentHeight = _a.contentHeight, attributes = _a.attributes;
    return (React.createElement("div", __assign({}, attributes, { ref: ref, className: classnames(s['root'], s[placement], wrapperClassName), style: simpleArrowPosition
            ? style
            : getArrowPositionStyles(style, placement, contentWidth, contentHeight) }),
        React.createElement("div", { className: classnames(s['arrow'], className) })));
});
PopoverArrow.displayName = 'PopoverArrow';
export default PopoverArrow;
//# sourceMappingURL=PopoverArrow.js.map